import * as THREE from "three";

const radius = 102.1;

const lineMaterial = new THREE.LineBasicMaterial({
  color: "grey"
});

// Returns a THREE.Group containing all the lines
function getGeoLines(features) {
  const lines = new THREE.Group();

  // GEOJSON to ThreeJS
  for (let i = 0; i < features.length; i++) {
    let feature = features[i];
    let coords: any = [];
    for (let c = 0; c < feature.geometry.coordinates.length; c++) {
      if (feature.geometry.type == "Polygon") {
        let coords: any = [];
        for (let s = 0; s < feature.geometry.coordinates[c].length; s++) {
          let xy: any = {
            x: feature.geometry.coordinates[c][s][0],
            y: feature.geometry.coordinates[c][s][1]
          };
          coords.push(xy);
        }

        if (coords.length > 0) {
          lines.add(createLineFromCoords(coords));
        }
      } else if (feature.geometry.type == "MultiPolygon") {
        for (let s = 0; s < feature.geometry.coordinates[c].length; s++) {
          //each polygon in multipolygon:
          let coords: any = [];
          for (let m = 0; m < feature.geometry.coordinates[c][s].length; m++) {
            let xy: any = {
              x: feature.geometry.coordinates[c][s][m][0],
              y: feature.geometry.coordinates[c][s][m][1]
            };
            coords.push(xy);
          }
        }
        if (coords.length > 0) {
          lines.add(createLineFromCoords(coords));
        }
      } else if (feature.geometry.type == "LineString") {
        let xy = {
          x: feature.geometry.coordinates[c][0],
          y: feature.geometry.coordinates[c][1]
        };
        coords.push(xy);
      }
    }
    if ((feature.geometry.type = "LineString")) {
      if (coords.length > 0) {
        lines.add(createLineFromCoords(coords));
      }
    }
  }

  return lines;
}

function createLineFromCoords(coords) {
  let lineGeom = new THREE.BufferGeometry();
  let positions: any = [];
  for (var i = 0; i < coords.length; i++) {
    let lat = coords[i].y;
    let lon = coords[i].x;
    let latRad = lat * (Math.PI / 180);
    let lonRad = -lon * (Math.PI / 180);
    let x = Math.cos(latRad) * Math.cos(lonRad) * radius;
    let y = Math.sin(latRad) * radius;
    let z = Math.cos(latRad) * Math.sin(lonRad) * radius;
    positions.push(x, y, z);
  }

  lineGeom.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));

  return new THREE.Line(lineGeom, lineMaterial);
}

export { getGeoLines };
